import React from 'react';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';

const PhotoCamera = (props) => <PhotoCameraIcon {...props} />;

export default PhotoCamera;
